import { useState, useEffect } from 'react';

import { Box } from '@mui/material';
import {
  Pets as AnimalIcon,
  Yard as CropIcon,
  Webhook as MixedIcon,
} from '@mui/icons-material';

import DataGrid from '../../../components/DataGrid/DataGrid';
import { simulation } from '../../../utils/api';
import colors from '../../../assets/colors';

export default function SimulationMultipleClients(props) {
  const columns = [
    {
      field: 'id',
      headerName: 'ID',
      type: 'number',
      hide: true,
      hideable: false,
      filterable: false,
      getApplyQuickFilterFn: undefined,
    },
    {
      field: 'name',
      headerName: 'Imię i nazwisko',
      minWidth: 150,
      flex: 1,
      valueGetter: (params) => {
        return `${params.row.name} ${params.row.surname}`;
      },
    },
    {
      field: 'productionType',
      headerName: 'Kategoria',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.value === 'animal' && (
              <AnimalIcon sx={{ color: colors.pink }} />
            )}
            {params.value === 'crop' && (
              <CropIcon sx={{ color: colors.agroweToxicGreen }} />
            )}
            {params.value === 'mixed' && (
              <MixedIcon sx={{ color: colors.brightYellow }} />
            )}
          </>
        );
      },
    },
    {
      field: 'incomeGroup',
      headerName: 'Grupa dochodowa',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {params.value === 'micro' && 'Mikro'}
            {params.value === 'medium' && 'Średnia'}
            {params.value === 'macro' && 'Makro'}
          </>
        );
      },
    },
    {
      field: 'isProductionExcluded',
      headerName: 'Branża wykluczona',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'fieldsArea',
      headerName: 'Powierzchnia upraw (ha)',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'voivodeship',
      headerName: 'Województwo',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'county',
      headerName: 'Powiat',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'commune',
      headerName: 'Gmina',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'region',
      headerName: 'Obręb',
      minWidth: 150,
      flex: 1,
    },
    {
      field: 'isCropProduction',
      headerName: 'Produkcja roślinna',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'cropIncome',
      headerName: 'Produkcja roślinna (zł)',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{Number(params.value?.toFixed(2))}</>;
      },
    },
    {
      field: 'isAnimalProduction',
      headerName: 'Produkcja zwierzęca',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
    {
      field: 'animalProductionIncome',
      headerName: 'Produkcja zwierzęca (zł)',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{Number(params.value?.toFixed(2))}</>;
      },
    },
    {
      field: 'liabilityValue',
      headerName: 'Wartość zadłużenia (zł)',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{Number(params.value?.toFixed(2))}</>;
      },
    },
    {
      field: 'isLiable',
      headerName: 'Zagrożenie',
      minWidth: 150,
      flex: 1,
      renderCell: (params) => {
        return <>{params.value ? 'Tak' : 'Nie'}</>;
      },
    },
  ];

  const rows = [
    {
      id: 0,
      name: 'Jan Kowalski',
      loanType: 'realEstate',
      email: 'email@email.com',
      incomeGroup: 'Test',
      isProductionExcluded: 'Tak',
      fieldsArea: 123,
      voivodeship: 'łódzkie',
      county: 'Łódź',
      commune: 'Łódź',
      region: 'Łódź',
      isCropProduction: 'Tak',
      directPaymentIncome: '123',
      isAnimalProduction: 'Tak',
      animalProductionIncome: '123',
      liabilitiesValue: '123',
      threat: 'Nie',
    },
  ];

  const [data, setData] = useState([]);

  useEffect(() => {
    simulation
      .result(props.resultID)
      .then((res) => {
        setData(res.data);
      })
      .catch((err) => {});
  }, [props.resultID]);

  const handleSelectionChange = (newSelection) => {
    props.setSelection(newSelection);
    const selectionDataFiltered = rows?.filter((param) => {
      if (newSelection.includes(param.id)) return param;
      else return null;
    });
    props.setClients(selectionDataFiltered);
  };

  return (
    <Box sx={{ mt: props.noMargin ? 0 : 10 }}>
      <DataGrid
        toolbar
        checkboxSelection
        selectionModel={props.selection}
        onSelectionModelChange={handleSelectionChange}
        columnData={columns}
        autoHeight
        rowData={data?.sort((a, b) => a.id - b.id)}
        sx={{ boxShadow: 3 }}
        componentsProps={{
          toolbar: {
            showQuickFilter: true,
            quickFilterProps: { debounceMs: 500 },
          },
        }}
      />
    </Box>
  );
}
